import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { url } from 'src/app/config/config';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
  })

export class CategoriaService {
    public httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',

        })
      };

    public myurl=url+"categoria/";
    constructor(private http:HttpClient){


    }
    listarCategoria(parametro){
      console.log(parametro)

      let body=JSON.stringify({'categoria':parametro});
      return  this.http.post(this.myurl+"getCategoriaAnexo.php",body,{headers:this.httpOptions.headers}).pipe(map(resp=>{
       // console.log("respuesta "+resp);
        return resp;

        }));
    }
    createAnexo(parametro:any){

        let body=JSON.stringify(parametro);

       console.log("url ",this.myurl+"createAnexo.php");
        return this.http.post(this.myurl+"createAnexo.php",body,{headers:this.httpOptions.headers}).pipe(map(resp=>{

          return resp;
        }));
      }
      deleteAnexo(id){
        const params = new HttpParams()
        .set('id',id.toString());
        console.log("parametros",params);
        return this.http.delete(this.myurl+"deleteAnexo.php",{params}).pipe(map(data=>{
          return data;
        }));
      }
}